export const identityAction = payload => payload
export const createIdentityAction = () => identityAction
export const createFormFailureAction = () => (
  {
    message,
    errors: {
      __all__: $messages = [],
      ...errors
    } = {}
  }
) => (
  {
    $messages: [...$messages, ...(message ? [message] : [])],
    ...errors
  }
)

export const createFormActions = (actionPrefix) => ({
  [actionPrefix]: createIdentityAction(),
  [`${actionPrefix}_SUCCESS`]: createIdentityAction(),
  [`${actionPrefix}_FAILURE`]: createFormFailureAction()
})
